// This file is generated by scripts/generate-proto-crud-services.ts

// @generated by protoc-gen-connect-query v1.4.2 with parameter "target=ts,import_extension="
// @generated from file _gen.user.service.proto (package user.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from '@bufbuild/protobuf'
import {
  CreateUserRequest,
  CreateUserResponse,
  DeleteUserRequest,
  DeleteUserResponse,
  GetUserByCognitoUserIdRequest,
  GetUserByCognitoUserIdResponse,
  GetUserByIdRequest,
  GetUserByIdResponse,
  GetUsersByEmailRequest,
  GetUsersByEmailResponse,
  GetUsersByNameRequest,
  GetUsersByNameResponse,
  GetUsersRequest,
  GetUsersResponse,
  UpdateUserRequest,
  UpdateUserResponse,
} from './_gen.user.service_pb'

/**
 * @generated from rpc user.v1.UserService.GetUserById
 */
export const getUserById = {
  localName: 'getUserById',
  name: 'GetUserById',
  kind: MethodKind.Unary,
  I: GetUserByIdRequest,
  O: GetUserByIdResponse,
  service: {
    typeName: 'user.v1.UserService',
  },
} as const

/**
 * @generated from rpc user.v1.UserService.GetUserByCognitoUserId
 */
export const getUserByCognitoUserId = {
  localName: 'getUserByCognitoUserId',
  name: 'GetUserByCognitoUserId',
  kind: MethodKind.Unary,
  I: GetUserByCognitoUserIdRequest,
  O: GetUserByCognitoUserIdResponse,
  service: {
    typeName: 'user.v1.UserService',
  },
} as const

/**
 * @generated from rpc user.v1.UserService.GetUsersByEmail
 */
export const getUsersByEmail = {
  localName: 'getUsersByEmail',
  name: 'GetUsersByEmail',
  kind: MethodKind.Unary,
  I: GetUsersByEmailRequest,
  O: GetUsersByEmailResponse,
  service: {
    typeName: 'user.v1.UserService',
  },
} as const

/**
 * @generated from rpc user.v1.UserService.GetUsersByName
 */
export const getUsersByName = {
  localName: 'getUsersByName',
  name: 'GetUsersByName',
  kind: MethodKind.Unary,
  I: GetUsersByNameRequest,
  O: GetUsersByNameResponse,
  service: {
    typeName: 'user.v1.UserService',
  },
} as const

/**
 * @generated from rpc user.v1.UserService.GetUsers
 */
export const getUsers = {
  localName: 'getUsers',
  name: 'GetUsers',
  kind: MethodKind.Unary,
  I: GetUsersRequest,
  O: GetUsersResponse,
  service: {
    typeName: 'user.v1.UserService',
  },
} as const

/**
 * @generated from rpc user.v1.UserService.CreateUser
 */
export const createUser = {
  localName: 'createUser',
  name: 'CreateUser',
  kind: MethodKind.Unary,
  I: CreateUserRequest,
  O: CreateUserResponse,
  service: {
    typeName: 'user.v1.UserService',
  },
} as const

/**
 * @generated from rpc user.v1.UserService.UpdateUser
 */
export const updateUser = {
  localName: 'updateUser',
  name: 'UpdateUser',
  kind: MethodKind.Unary,
  I: UpdateUserRequest,
  O: UpdateUserResponse,
  service: {
    typeName: 'user.v1.UserService',
  },
} as const

/**
 * @generated from rpc user.v1.UserService.DeleteUser
 */
export const deleteUser = {
  localName: 'deleteUser',
  name: 'DeleteUser',
  kind: MethodKind.Unary,
  I: DeleteUserRequest,
  O: DeleteUserResponse,
  service: {
    typeName: 'user.v1.UserService',
  },
} as const
